import { AnyAction } from 'redux';
import { CheckoutActions } from '../checkout.actions';
import { Vorversicherer } from '../data/vorversicherung';

export const versicherungDataReducer = function (
  sectionState: Array<Vorversicherer> = null,
  action: AnyAction,
): Array<Vorversicherer> {
  switch (action.type) {
    case CheckoutActions.VORVERSICHERERLISTE_RETRIEVED: {
      return action.payload;
    }
    default:
      return sectionState;
  }
};
